import { render } from "./LinkedEmails.vue?vue&type=template&id=8005a2e6"
import script from "./LinkedEmails.vue?vue&type=script&lang=js"
export * from "./LinkedEmails.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__